import { render, staticRenderFns } from "./dashboardHeaderTool.vue.js?vue&type=template&id=06b538d7!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./dashboardHeaderTool.vue?vue&type=template&id=06b538d7"
import script from "./dashboardHeaderTool.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./dashboardHeaderTool.vue?vue&type=script&lang=js"
export * from "./dashboardHeaderTool.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./dashboardHeaderTool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports